<template>
  <div class="btn_group">
    <button
      v-if="buttonStates.reorder"
      type="button"
      class="btn_default-b"
      @click="$emit('on-reorder')"
    >
      재주문
    </button>
    <button
      v-if="buttonStates.orderCancel"
      type="button"
      class="btn_default-a"
      @click="onCancelPack('single')"
    >
      주문취소
    </button>
    <button
      v-if="buttonStates.cancelSubscription"
      type="button"
      class="btn_default-a"
      @click="onCancelPack('recurring')"
    >
      정기구매 취소
    </button>
    <button
      v-if="buttonStates.changePaymentInfo"
      type="button"
      class="btn_default-a"
      @click="onChangePaymentInfo"
    >
      결제정보 변경
    </button>
    <button
      v-if="buttonStates.resendConsultationUrl"
      type="button"
      class="btn_default-b"
      @click="onResendConsultationUrl"
    >
      상담 URL 재발송
    </button>
    <button
      v-if="buttonStates.resendConsultationInfo"
      type="button"
      class="btn_default-b"
      @click="onResendConsultationInfo"
    >
      상담 안내 재발송
    </button>
    <button
      v-if="buttonStates.resendSubscriptionUrl"
      type="button"
      class="btn_default-b"
      @click="onResendSubscriptionUrl"
    >
      정기구매 URL 재발송
    </button>
    <button
      v-if="buttonStates.approvedSubscription"
      type="button"
      class="btn_default-b"
      @click="onApprovedSubscription"
    >
      정기구매 승인
    </button>
    <button
      v-if="buttonStates.paymentCancel"
      type="button"
      class="btn_default-a"
      @click="$emit('on-cancel-order')"
    >
      결제 취소
    </button>
    <!-- onOrder -->
    <button
      v-if="buttonStates.checkout"
      type="button"
      class="btn_default-b"
      @click="$emit('on-order')"
    >
      즉시 결제
    </button>
    <!-- [ASB-13103]: [마이팩] 즉시결제 할부 기능 업데이트-->
    <button
      v-if="buttonStates.paymentInstallment"
      type="button"
      class="btn_default-b"
      @click="$emit('on-payment-installment')"
    >
      즉시 결제
    </button>
    <!-- [ASB-13103]: [마이팩] 즉시결제 할부 기능 업데이트-->
    <button
      v-if="buttonStates.stockCheckAndCheckout"
      type="button"
      class="btn_default-a"
      @click="$emit('on-order')"
    >
      재고 확인 및 결제
    </button>
    <modal-alert ref="refAlert" />
    <modal-confirm ref="refConfirm" />
  </div>
</template>
<script>
import { axios, axiosGet, http } from '@/utils/http';
import { mapGetters } from "vuex";
import packApi from "@/apis/pack";
import { log } from "@/utils/common";
import { JSON_HEADER } from '@/utils/constants';
import ModalAlert from "@/components/global/ModalAlert";
import ModalConfirm from "@/components/global/ModalConfirm";
import compositionHelpers from '@/utils/helpers/composition';

export default {
  name: "MypacksItemBtnGroup",
  components: {
    ModalAlert,
    ModalConfirm,
  },
  props: {
    buttonStates: {
      type: Object,
      default: () => ({}),
    },
    reqNo: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      productsDetails: [],
    };
  },
  computed: {
    ...mapGetters({
      products: "product/productsAll",
      productsFetched: "product/productsFetched",
    }),
  },
  methods: {
    // 주문 취소
    async onCancelPack(purchaseType) {
      const confirmMessage =
        purchaseType == "single"
          ? "해당 마이팩 주문을 취소 하시겠습니까?"
          : "해당 마이팩 정기구매를 취소 하시겠습니까?";

      const alertMessage =
        purchaseType == "single"
          ? "마이팩 주문이 취소되었습니다."
          : "마이팩 정기구매가 취소되었습니다.";

      try {
        await this.$refs.refConfirm.openWithMessage(confirmMessage);
        const r = await packApi.cancelConsultationApplied(this.reqNo);
        if (r) {
          await this.$refs.refAlert.openWithMessage(alertMessage);
          this.$emit("item-state-change");
        }
      } catch (e) {
        log("MyPackItemBtnGroup::onClickDoCancel", "canceled");
      }
    },
    async onChangePaymentInfo() {
      // this.$refs.refAlert.openWithMessage("결제 정보 변경");
      const result = await compositionHelpers.doCompositionPaymentFromMypack(
        this.$store,
        this.reqNo,
      );
      if (result) {
        this.$router.push({
          name: "composition-payment",
        });
      }
    },
    async onResendConsultationUrl() {
      log('MypacksItemBtnGroup::onResendConsultationUrl', 'Resend consultation url...');
      const { result } = await http.post("/kakao", {
        message_key: "mypack",
        req_no: this.reqNo,
      }, JSON_HEADER);
      this.$refs.refAlert.openWithMessage(
        "카카오톡 알림톡을 통해\n채팅 상담 URL이 재발송 되었습니다."
      );
    },
    async onResendConsultationInfo() {
      log('MypacksItemBtnGroup::onResendConsultationInfo', 'Resend consultation info...');
      const { result } = await http.post("/kakao", {
        message_key: "mypack",
        req_no: this.reqNo,
      }, JSON_HEADER);
      this.$refs.refAlert.openWithMessage(
        "카카오톡 알림톡을 통해\nABC 방문 상담 안내가 재발송 되었습니다."
      );
    },
    async onResendSubscriptionUrl() {
      log('MypacksItemBtnGroup::onResendSubscriptionUrl', 'Resend subscription url...');
      const { result } = await http.post("/kakao", {
        message_key: "mypack",
        req_no: this.reqNo,
      }, JSON_HEADER);
      this.$refs.refAlert.openWithMessage(
        "카카오톡 알림톡을 통해\n정기 구매 URL이 재발송 되었습니다."
      );
    },
    onApprovedSubscription() {
      this.$router.push(`/mypacks/consultation/${this.reqNo}`);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/main/partial/MypacksItemBtnGroup.vue